import { Directive, EmbeddedViewRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureToggleService } from '../../services/feature-toggle/feature-toggle.service';

@Directive({selector: '[cfnIsFeatureActive]'})
export class IsFeatureActiveDirective {
    private viewRef: EmbeddedViewRef<void>|null = null;

    constructor(
        private viewContainer: ViewContainerRef,
        private templateRef: TemplateRef<void>,
        private featureToggleService: FeatureToggleService
    ) {}

    @Input()
    set cfnIsFeatureActive(identifier: string) {
        const isActive = this.featureToggleService.isFeatureActivated(identifier);
        if(isActive) {
            if (!this.viewRef) {
                this.viewContainer.clear();
                this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
            }
        } else {
            this.viewContainer.clear();
        }
    }

}

